import { Injectable, inject } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { ApiResponse } from '@interfaces/response';
import { Observable } from 'rxjs';
import {Company} from '@interfaces/company';

@Injectable({
  providedIn: 'root'
})
export class CompaniesApiService {

  private api_service = inject(ApiService);
  
  private company_list_url = "/companies/companies"
  
  constructor() { }
  
  public get_company_list(params?: any): Observable<ApiResponse<Company[]>> {
    return this.api_service.get<ApiResponse<Company[]>>(this.company_list_url, params);
  }
  
}